import { URI } from '@/config/config';

export default async ({ rootState }, { userToken }) => {
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
    },
  };
  const path = new URL(`${URI}control-panel/consumer/${userToken}`);

  const response = await fetch(path, opts);
  const jsonResult = await response.json();
  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors);
  }

  return jsonResult;
};
